@if (!isMobile) {
  <div class="bin-events-container">
    @if(binEvents.length > 0){
      <div class="header-container">
        <div class="search-container">
          <img class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />
          <input class='search-input' type="text" (input)="applyFilter($event.target)" placeholder="{{'OTHER.SEARCH' | translate }}" id="bin-search-input">
        </div>
        <div class="clear-all" (click)="clearAllBinEvents()" rtlDiv>
          {{ 'LIVE_INFO.CLEAR_ALL' | translate }}
        </div>
      </div>
    }
    <div class="bin-events-list">
      @for (binEvent of binEvents; track binEvent; let i = $index) {
        <div class='bin-event-container'>
          <div class="flex-container">
            <div class="bin-event-text-container">
              <div class="bin-event-id">{{binEvent.event_id}} |</div>
              <div>&nbsp;</div>
              <div class='bin-event-text'>{{currentLang != 'iw' ? binEvent.event_body : binEvent.event_body_hebrew}}</div>
            </div>
            <img class="bin-event-remove-btn" (click)="removeBinEvent(i)" src="assets/images/binInfoPage/remove_bin_event.svg" alt="remove_bin_event" rtlDiv/>
          </div>
          <div class="bin-event-date">
            {{currentLang != 'iw' ? validateDateEn(binEvent.event_time) : validateDateIw(binEvent.event_time)}}
          </div>
        </div>
      }
    </div>
  </div>
}

@if (isMobile) {

}
